import { render, staticRenderFns } from "./InsuranceSubprogramCreatePageOMS.vue?vue&type=template&id=5088605c&scoped=true"
import script from "./InsuranceSubprogramCreatePageOMS.vue?vue&type=script&lang=js"
export * from "./InsuranceSubprogramCreatePageOMS.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSubprogramCreatePageOMS.vue?vue&type=style&index=0&id=5088605c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088605c",
  null
  
)

export default component.exports